<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">未归类照片</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" :inline="true">
        <el-form-item label="分片名称:">{{ basicInfo.folderName }}</el-form-item>
        <el-form-item label="照片张数:"> {{ basicInfo.number }} </el-form-item>
        <el-form-item label="未归类照片数:"> {{ basicInfo.unclassifiedNumber }} </el-form-item>
      </el-form>
      <el-tabs v-model="comment" @tab-click="handleClick" style="margin-left: 100px;margin-right: 100px;">
        <el-tab-pane :label="'未归类(' + status1 + ')'" name="0"></el-tab-pane>
        <el-tab-pane :label="'手动归类(' + status2 + ')'" name="1"></el-tab-pane>
      </el-tabs>
      <div class="image-list">
        <el-image v-for="(item, index) in imageList" :key="index" :src="item.url + '?x-sds-process=image/resize,l_200,m_mfit'" :preview-src-list="[item.url]" style="height: 100px;margin-left: 10px;">
        </el-image>
      </div>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { queryByRecordsId } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      status1: 0,
      status2: 0,
      imageList: [],
      comment: 0,
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = this.$route.query.id
    queryByRecordsId(id).then((res) => {
      if (res.data.success) {
        this.basicInfo = res.data.data
        this.imageList = res.data.data.noClassifyPhotos.filter(a => a.status == '0')
        this.status1 = res.data.data.noClassifyPhotos.filter(a => a.status == '0').length
        this.status2 = res.data.data.noClassifyPhotos.filter(a => a.status == '1').length
      }
    })
  },
  methods: {
    handleClick (val) {
      console.log('val', val.name)
      this.imageList = this.basicInfo.noClassifyPhotos.filter(a => a.status == val.name)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
